import { useLocalStorageState } from "../../hooks/useLocalStorageState";
import { uiNotification } from "../../services/UINotificationService";
import { inc } from "../../utilities/fp";

/**
 * @param {{
 *  id: string;
 *  maxAttempts: number;
 *  initialAttemptsAmount: number;
 *  cooldownId: string;
 *  cooldownMs: number;
 *  message: string;
 * }} config
 */
export const useFnCallRateLimit = ({
  id,
  maxAttempts,
  initialAttemptsAmount,
  cooldownId,
  cooldownMs,
  message,
}) => {
  const [count, setCount] = useLocalStorageState(id, initialAttemptsAmount, {
    transform: Number,
    enableInit: false,
  });

  const [cd, setCd] = useLocalStorageState(cooldownId, 0, {
    transform: Number,
    enableInit: false,
  });

  const call = (fn, onLimitReached) => {
    let c = count;

    if (cd && Date.now() - cd >= cooldownMs) {
      setCd(0);
      setCount(0);
      c = 0;
    }

    if (c >= maxAttempts) {
      uiNotification.error(message);
      if (!cd) setCd(Date.now());
      return onLimitReached?.();
    }

    if (c + 1 >= maxAttempts) {
      setCd(Date.now());
    }

    setCount(inc);
    fn();
  };

  return {
    call,
  };
};
